// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__+gaHr","active":"RoomScene_active__DH+Em"};